import React, { lazy } from "react";
import history from "helper/history";
import ReactTooltip from "react-tooltip";
import moment from "moment";

import {
    CustomTextField as TextField,
    CustomDatePicker as DatePicker,
    CustomMenuItem as MenuItem,
    CustomIconButton as IconButton,
    CustomIconMenu as IconMenu,
    CustomBadge as Badge,
    ReactTags
} from "../customComponents/components";

// const TextField = lazy(() => import("../customComponents/textField"));
// const DatePicker = lazy(() => import("../customComponents/customDatePicker"));
// const MenuItem = lazy(() => import("../customComponents/customMenuItem"));
// const IconButton = lazy(() => import("../customComponents/iconButton"));
// const IconMenu = lazy(() => import("../customComponents/customIconMenu"));
// const Badge = lazy(() => import("../customComponents/customBadge"));
// const ReactTags = lazy(() => import("../customComponents/reactTags"));

import ExtraFieldStores from "../stores/extrafieldstores";
import dispatcher from "../dispatchers/dispatcher";
import Url from "./urls";
import UserInfoStore from "../stores/userInfoStores";
import Common from "./common";
import Inmailapproval from "../pages/autoRedirect";
import { _callAPI, _callMultipleApi, _callApiWithoutBaseURL } from "./axios";

import GenericValidation from "./validation";
import i18n from "../i18nNext";

let dependentEFTags = {};
let previousEFId = "";
const ignoreLocal = ["localhost", "0.0.0.0"];

const api = {
    isSecure() {
        // this will determine whether we save cookie in secure mode or not
        if (process.env.NODE_ENV === "production" && window.location.protocol === "https:") {
            return "secure;";
        }
        return "";
    },
    getDomain() {
        let domain = "";
        if (!ignoreLocal.includes(window.location.hostname)) {
            domain =
                ";domain=" +
                window.location.hostname.substring(window.location.hostname.indexOf("."));
        } else {
            domain = ";domain=" + window.location.hostname;
        }
        return domain;
    },
    getDomainPrefix(notAppendHappay) {
        let domainPrefix = window.location.hostname.substring(
            window.location.hostname.indexOf(".") + 1
        );
        domainPrefix = domainPrefix.substring(0, domainPrefix.lastIndexOf("."));
        if (notAppendHappay) {
            domainPrefix = domainPrefix.replace("happay", "");
            if (domainPrefix.indexOf(".") === domainPrefix.length - 1) {
                domainPrefix = domainPrefix.replace(".", "");
            }
        }
        return domainPrefix;
        // let domainPrefix = "";
        // if (ignoreLocal.includes(window.location.hostname)) {
        //     domainPrefix = window.location.host + ".";
        // }
    },
    _setKey(key, value, notAppendHappay = false) {
        localStorage.setItem((!notAppendHappay ? "happay." : "") + key, value);
        this._setCookie(key, value, notAppendHappay);
    },
    _setCookie(key, value, notAppendHappay = false) {
        const d = new Date();
        d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
        const expires = `expires=${d.toUTCString()}`;
        document.cookie = `${this.getDomainPrefix(
            notAppendHappay
        )}.${key}=${value};${expires}${this.getDomain()};path=/;${this.isSecure()}`;
        // document.cookie =
        //     (!notAppendHappay ? "happay." : "") +
        //     this.getDomainPrefix(notAppendHappay) +
        //     key +
        //     "=" +
        //     value +
        //     ";" +
        //     expires +
        //     this.getDomain() +
        //     ";path=/;" +
        //     this.isSecure();
    },
    _getKey: function(key) {
        if (!window.location.hostname) return localStorage.getItem("happay." + key);
        return this._getCookieValue(key);
    },
    _setKeyinBulk: function(obj) {
        for (let i in obj) localStorage.setItem("happay." + i, obj[i]);
    },
    _getCookieValue(key, notAppendHappay = false) {
        // let name = (!notAppendHappay ? "happay." : "") + this.getDomainPrefix(notAppendHappay) + key + "=";
        const name = `${this.getDomainPrefix(notAppendHappay)}.${key}=`;
        const ca = document.cookie.split(";");
        for (let i = 0; i < ca.length; i += 1) {
            let c = ca[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                const value = c.substring(name.length, c.length);
                // This check is because we parse the JSON for this value
                if (key === "sizePerPageData" && !value) {
                    return "{}";
                }
                return value;
            }
        }

        // This check is because we parse the JSON for this value
        if (key === "sizePerPageData") {
            return "{}";
        }
        return "";
    },
    _removeKey: function(key, notAppendHappay = false) {
        localStorage.removeItem((!notAppendHappay ? "happay." : "") + key);
        this._removeCookie(key, notAppendHappay);
    },
    _removeCookie(key, notAppendHappay = false) {
        const d = new Date();
        d.setTime(d.getTime() - 24 * 60 * 60 * 1000);
        const expires = `expires=${d.toUTCString()}`;
        document.cookie = `${this.getDomainPrefix(
            notAppendHappay
        )}.${key}=;${expires}${this.getDomain()};path=/;${this.isSecure()}`;
        // document.cookie =
        //     (!notAppendHappay ? "happay." : "") +
        //     key +
        //     "=;" +
        //     expires +
        //     this.getDomain() +
        //     ";path=/;" +
        //     this.isSecure();
    },
    _clearStorage: function() {
        let len = localStorage.length;
        for (let i = len - 1; i >= 0; i--) {
            let key = localStorage.key(i);
            if (key != null && key != undefined && key.indexOf("happay.") == 0) {
                localStorage.removeItem(key);
            }
        }
        if (localStorage["hardware_id"]) {
            localStorage.removeItem("hardware_id");
        }
        if (localStorage["gmail-addon-info"]) {
            localStorage.removeItem("gmail-addon-info");
        }
        if (localStorage.minKycDiv) {
            localStorage.removeItem("minKycDiv");
        }
        if (localStorage.flexiElements) {
            localStorage.removeItem("flexiElements");
        }
        let ca = document.cookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = (ca[i] || "").trim();
            if (c.indexOf(this.getDomainPrefix()) === 0) {
                const name = c
                    .substring(0, c.indexOf("="))
                    .replace(`${this.getDomainPrefix()}.`, "");
                this._removeCookie(name);
            }
        }
    },
    _formatExchangeRate(camt, amt) {
        let eR = amt / camt;
        if (Object.is(NaN, eR) || eR === Infinity) return false;
        return (amt / camt).toFixed(2);
    },

    _formatAmount: function(amount) {
        // can not pass currency as it will take currency symbole twice
        return i18n.t("interpolation.number", { number: amount });
    },

    _formatName: function(name) {
        if (!name) return "...";
        return name
            .split(" ")
            .map((el, i) => {
                if (i !== 0 && el && el.length) return el[0].toUpperCase();
                return el;
            })
            .join(" ");
    },

    _formatDate: function(date, format) {
        let finalDateFormat = moment
            .utc(date || undefined)
            .local()
            .format(format || "lll");
        return finalDateFormat;
    },

    _formatLocaleDate: function(date = new Date(), format = "DD MMM YYYY") {
        let finalDateFormat = i18n.t("interpolation.dateTime", { dateTime: date });
        if (format === "DD MMM YYYY") {
            finalDateFormat = i18n.t("interpolation.date", { date: date });
        } else if (format === "h:mm a") {
            finalDateFormat = i18n.t("interpolation.time", { time: date });
        } else if (format === "MMM") {
            finalDateFormat = i18n.t("interpolation.month", { month: date });
        } else if (format === "DD MMM YYYY hh:mm A") {
            finalDateFormat = i18n.t("interpolation.dateTime1", { dateTime1: date });
        }

        return finalDateFormat;
    },

    _formatLocaleDatenoUTC: function(date = new Date(), format = "DD MMM YYYY") {
        let finalDateFormat = i18n.t("interpolationLocal.dateTime", { dateTime: date });

        if (format === "YYYY-MM-DD") {
            finalDateFormat = i18n.t("interpolationLocal.date", { date: date });
        } else if (format === "HH:mm") {
            finalDateFormat = i18n.t("interpolationLocal.time", { time: date });
        } else if (format === "MMM") {
            finalDateFormat = i18n.t("interpolationLocal.month", { month: date });
        }

        return finalDateFormat;
    },

    _sendFormatDate: function(date, format) {
        let finalDateFormat = moment.utc(date).format(format || "lll");
        // let finalDateFormat = moment.utc(date).local().format(format||'lll');
        return finalDateFormat;
    },

    _showErrorMsg: function(status, obj) {
        let msg = "";
        if (status == 404 || status == 0) {
            if (!navigator.onLine)
                msg =
                    "It seems your internet connection is down.Please try to connect to internet first and try again";
            else
                msg =
                    "It seems something wrong with your internet.Please check your internet connection and try again";
        } else if (status == 400) {
            msg =
                obj && obj.res_str
                    ? obj.res_str
                    : "Sorry to process your request right now.If you are not expecting this please contact help@happay.com";
        } else if (status == 403) {
            msg = "You are not permitted for this action";
        } else if (status == 405) {
            msg = "Method Not Allowed";
        } else if (status == 500) {
            msg =
                "Sorry to process your request right now.If you are not expecting this please contact help@happay.com";
        } else if (Common._checkIfHdfcUrl() && status === 401 && obj?.res_str === "You have entered invalid username or password.") {
            // FOR HDFC Poweredby Login error msg
                msg =
                "Invalid User. Please ensure you are part of HDFC Bank Prepaid Expense program.";
        }
         else {
                   msg = "Sorry! Could not process your request currently, please try after some time.";
               }
        // console.log(status,msg);
        return msg;
    },
    _checkboxOnCheck: function(fId, type, event, value) {
        this._handleExtraCommon(type, fId, value);
    },
    _handleExtraDependentCommon: function(type, fId, fValue) {
        let dep_ef = ExtraFieldStores._getextraFields("dependent") || {};
        if (type === "number") {
            // let insert = (parseInt(fValue.trim()) !== NaN) && (parseInt(fValue.trim())+'').length === fValue.length ? true : false;
            // if(insert && fValue){
            // 	dep_ef[fId] = fValue;
            // }
            // else if(fValue===''){
            // 	dep_ef[fId] = fValue;
            // }
            if (GenericValidation._amountValidation(fValue) < 0) {
                return;
            } 
                dep_ef[fId] = GenericValidation._amountValidation(fValue);
            
        } else if (type === "multi_select_dropdown" || type === "dropdown") {
            // console.log('dropdown',fValue);
            //If there is no value selected then blank array should be its default value and send this server as string
            dep_ef[fId] = fValue || [];
        } else if (type === "text") {
            dep_ef[fId] = GenericValidation._textFieldValidation(fValue);
        } else {
            dep_ef[fId] = fValue;
        }
        // console.log("dep_ef",dep_ef);
        ExtraFieldStores._editExtraFieldDependent("dependent", dep_ef);
    },
    _handleExtraCommon: function(type, fId, fValue, fieldName, status) {
        let extraFields = [];
        if (type == "txn_expression") {
            extraFields = ExtraFieldStores._getExpressionExtraField("txn_expression");
        } else {
            extraFields = ExtraFieldStores._getextraFields(type);
        }
        // console.log(type,fId,fValue,extraFields.length);
        for (let i in extraFields) {
            let oneEF = extraFields[i];
            if (oneEF.field_id == fId && oneEF.name_type !== "file") {
                if (["number", "BACC", "IFSC"].indexOf(oneEF.name_type) !== -1)
                    fValue = fValue.trim();
                if (oneEF.name_type === "number") {
                    // console.log('fValue',fValue);
                    // let patt1 = /[0-9]/g;
                    // // let insert = (parseInt(fValue.trim()) !== NaN) && (parseInt(fValue.trim())+'').length === fValue.length ? true : false;
                    // let insert = (parseInt(fValue.trim()) !== NaN) && (parseInt(fValue.trim())+'').length === fValue.length ? true : false;
                    // if(!/[^0-9]/.test(fValue)==true && fValue){
                    // 	oneEF[fieldName||'fieldValue'] = fValue;
                    // }
                    // else if(fValue===''){
                    // 	oneEF[fieldName||'fieldValue'] = fValue;
                    // }
                    if (GenericValidation._amountValidation(fValue) < 0) {
                        return;
                    } 
                        oneEF[fieldName || "fieldValue"] = GenericValidation._amountValidation(
                            fValue
                        );
                    
                } else if (oneEF.name_type === "BACC") {
                    let insert = /[^a-zA-Z0-9]/.test(fValue);
                    if (!/[^a-zA-Z0-9]/.test(fValue) && fValue) {
                        oneEF[fieldName || "fieldValue"] = fValue;
                    } else if (fValue === "") {
                        oneEF[fieldName || "fieldValue"] = fValue;
                    }
                } else if (oneEF.name_type === "multi_select_dropdown") {
                    //If there is no value selected then blank array should be its default value and send this server as string
                    oneEF[fieldName || "fieldValue"] = fValue || [];
                } else if (oneEF.name_type === "dropdown") {
                    // console.log('fieldValue',fValue);
                    if (fValue == "No values selected") {
                        oneEF[fieldName || "fieldValue"] = "";
                    } else {
                        oneEF[fieldName || "fieldValue"] = fValue;
                    }
                } else if (oneEF.name_type === "IFSC") {
                    if (!/[^a-zA-Z0-9]/.test(fValue) && fValue.length <= 11) {
                        oneEF[fieldName || "fieldValue"] = fValue || "";
                    } else if (fValue === "") {
                        oneEF[fieldName || "fieldValue"] = fValue;
                    }

                    if (!/[^a-zA-Z0-9]/.test(fValue) && fValue.length == 11) {
                        let query = { ifsc_code: fValue };
                        // console.log('Url.GET_IFSC',Url.GET_IFSC);
                        this._callAPI(Url.GET_IFSC, "get", query, (type, dt) => {
                            if (type == "success") {
                                let data = dt.res_data;
                                oneEF["bank_name"] = data.bank.bank_name;
                                oneEF["branch_name"] = data.bank.branch_name;
                                ExtraFieldStores._editExtraFieldMain(type, extraFields);
                            } else {
                                dispatcher.dispatch({
                                    type: "TOAST",
                                    str: this._showErrorMsg(dt.status, dt.responseJSON || ""),
                                    toastType: 1
                                });
                            }
                        });
                    }
                } else if (oneEF.name_type === "text") {
                    oneEF[fieldName || "fieldValue"] = GenericValidation._textFieldValidation(
                        fValue
                    );
                } else {
                    oneEF[fieldName || "fieldValue"] = fValue;
                    console.log("oneEF", oneEF);
                }
            } else if (oneEF.field_id == fId && oneEF.name_type === "file") {
                let fileValues = {};
                let fileValueLength = 0;
                oneEF["billUrls"] = oneEF["billUrls"] || [];

                let fileValue =
                    fieldName == "delete" ? [] : oneEF.fieldValue ? oneEF.fieldValue : [];
                for (let k in fValue) {
                    if (fValue[k].type) {
                        fileValues[k] = fValue[k];
                        fileValueLength++;
                    }
                }

                for (let k in fileValue) {
                    if (fileValue[k].constructor === Object) {
                        fileValueLength += Object.keys(fileValue[k]).length;
                    } else {
                        fileValueLength++;
                    }
                }
                let maxCount = oneEF.max_attachment;
                if (fileValueLength > maxCount) {
                    let msg = "Max file that can be attached is " + maxCount;
                    UserInfoStore.showNewSnackbar(msg, 1);
                    fileValue =
                        fieldName == "delete" ? [] : oneEF.fieldValue ? oneEF.fieldValue : [];
                    document.getElementById("myEFFile-" + fId).value = "";
                    return false;
                } else if (fileValue.length > 5) {
                    let msg = "Max file that can be attached at a time is 5.";
                    UserInfoStore.showNewSnackbar(msg, 1);
                    fileValue =
                        fieldName == "delete" ? [] : oneEF.fieldValue ? oneEF.fieldValue : [];
                    document.getElementById("myEFFile-" + fId).value = "";
                    return false;
                } 
                    for (let k in fValue) {
                        if (fValue[k].type) {
                            let oFReader = new FileReader();
                            let newBill = "";
                            oFReader.onload = function(oFREvent) {
                                newBill = oFREvent.target.result;
                            };
                            oFReader.readAsDataURL(fValue[k]);
                            setTimeout(() => {
                                oneEF["billUrls"].push(newBill);
                            }, 200);
                        }
                    }
                    let newFile = [];
                    if (oneEF["fieldValue"].constructor == Object) {
                        oneEF["prevfieldValue"] = oneEF["fieldValue"];
                        for (let j in oneEF["fieldValue"]) {
                            newFile.push(oneEF["fieldValue"][j]);
                        }
                        oneEF["fieldValue"] = newFile;
                    } else {
                        oneEF["fieldValue"] = fileValue;
                    }
                    for (let k in fileValues) {
                        oneEF["fieldValue"].push(fileValues[k]);
                    }
                
            }
        }
        ExtraFieldStores._editExtraFieldMain(type, extraFields);
        if (type == "txn_expression") {
            dispatcher.dispatch({
                type: "COMPUTE_NOW"
            });
        }
    },
    _handleExtraFieldChange: function(fId, type, event, value) {
        this._handleExtraCommon(type, fId, value);
    },
    _handleDependentExtraFieldChange: function(fId, type, event, value) {
        // dependentEFChange = true;
        // console.log('_handleDependentExtraFieldChange',type,fId,value);
        this._handleExtraDependentCommon(type, fId, value);
    },

    _setUploadedFilesName(fId, type, isDisabled) {
        let files = [];
        let uiItems = [];
        let src = "";
        let extraFields = ExtraFieldStores._getextraFields(type);

        for (let i in extraFields) {
            if (extraFields[i].field_id == fId && extraFields[i].name_type === "file") {
                if (extraFields[i]["fieldValue"].constructor == Object) {
                    for (let j in extraFields[i]["fieldValue"]) {
                        files.push(extraFields[i]["fieldValue"][j]);
                    }
                } else {
                    files = extraFields[i]["fieldValue"] ? extraFields[i]["fieldValue"] : [];
                }
            }
        }
        if (files.length) {
            for (let i = 0; i < files.length; i++) {
                if (files[i].constructor !== Object) {
                    let displayName = files[i].name ? files[i].name : files[i];
                    src = displayName.indexOf(".pdf") != -1 ? "/assets/images/pdf.svg" : "/assets/images/img.svg";
                    displayName = displayName.substring(0, 9) + "...";
                    // console.log('fileValue', displayName, "name", files[i], files[i].name);
                    uiItems.push(
                        <div key={`upload-${files[i].name}-${i}`}>
                            <Badge
                                style={{
                                    paddingTop: 6,
                                    paddingBottom: 0,
                                    paddingRight: 15,
                                    paddingLeft: 0
                                }}
                                badgeStyle={
                                    !isDisabled
                                        ? {
                                              top: "1px",
                                              right: "16px",
                                              height: "18px",
                                              width: "18px"
                                          }
                                        : { backgroundColor: "transparent" }
                                }
                                badgeContent={
                                    !isDisabled ? (
                                        <span>
                                            <IconButton
                                                data-place="top"
                                                data-tip={files[i].name || files[i]}
                                                // tooltipPosition="top-center"
                                                // tooltip={files[i].name || files[i]}
                                                iconClassName="material-icons"
                                                style={{ float: "right", cursor: "pointer" }}
                                                onClick={this._handleDeleteUploadedImages.bind(
                                                    this,
                                                    i,
                                                    fId,
                                                    extraFields,
                                                    type
                                                )}
                                            >
                                                clear
                                            </IconButton>
                                            <ReactTooltip />
                                        </span>
                                    ) : (
                                        <span></span>
                                    )
                                }
                            >
                                <img style={{ width: "50px", height: "50px" }} src={src} />
                                {/*<Paper
								    	zDepth={1} 
								    	onClick={this._setName.bind(this,fId,extraFields,type)}
								    	style={{border: '1px #eee solid',background:'#eee',height: '50px',width: '50px',cursor:'pointer'}}>
								    </Paper>*/}
                            </Badge>
                            <div
                                onClick={this._setName.bind(this, fId, extraFields, type)}
                                style={{
                                    fontFamily: "Roboto-Light",
                                    fontSize: 12,
                                    marginLeft: 12,
                                    marginTop: "10px",
                                    cursor: "pointer"
                                }}
                            >
                                {i18n.t("lbl.files")}-{i + 1}
                            </div>
                        </div>
                    );
                }
            }
        }
        // ExtraFieldStores._editExtraFieldMain(type,extraFields);
        return uiItems;
    },
    _setName(fId, extraFields, type) {
        for (let i in extraFields) {
            if (extraFields[i].field_id == fId && extraFields[i].name_type === "file") {
                extraFields[i]["showLightBox"] = true;
            }
        }
        ExtraFieldStores._editExtraFieldMain(type, extraFields);
    },
    readAndPreview(file) {
        let oFReader = new FileReader();
        let newBill = "";
        oFReader.onload = function(oFREvent) {
            newBill = oFREvent.target.result;

            // newBillUrls.push(oFREvent.target.result);
        };
        oFReader.readAsDataURL(file);
        // console.log('newBill',newBill);
        // return newBill;
        setTimeout(() => {
            // console.log('newBill1111',newBill);
            return newBill;
        }, 200);
    },
    _closeLightbox(fId, type) {
        let extraFields = ExtraFieldStores._getextraFields(type);
        for (let i in extraFields) {
            if (extraFields[i].field_id == fId && extraFields[i].name_type === "file") {
                extraFields[i]["showLightBox"] = false;
            }
        }
        ExtraFieldStores._editExtraFieldMain(type, extraFields);
    },
    _handleDeleteUploadedImages(itemIndex, fId, extraFields, type, status) {
        let files = [];
        let newFile = [];
        let efIndex = "";
        // console.log('_handleDeleteUploadedImages',itemIndex,fId);
        for (let i in extraFields) {
            if (extraFields[i].field_id == fId && extraFields[i].name_type === "file") {
                if (extraFields[i]["fieldValue"].constructor == Object) {
                    extraFields[i]["prevfieldValue"] = extraFields[i]["fieldValue"];
                    for (let j in extraFields[i]["fieldValue"]) {
                        newFile.push(extraFields[i]["fieldValue"][j]);
                    }
                    extraFields[i].fieldValue = newFile;
                } else {
                    newFile = extraFields[i]["fieldValue"] ? extraFields[i]["fieldValue"] : [];
                }
            }
        }
        for (let i in extraFields) {
            if (extraFields[i].field_id == fId) {
                efIndex = i;
                for (let k in extraFields[i]["fieldValue"]) {
                    if (extraFields[i]["fieldValue"][k].constructor === String) {
                        files.push(extraFields[i]["fieldValue"][k]);
                    } else {
                        files.push(extraFields[i]["fieldValue"][k].name);
                    }
                }
            }
        }

        let items = files.filter((item, index) => {
            if (itemIndex != index) {
                return item;
            }
        });
        // console.log('items',items,extraFields[i].billUrls);
        extraFields[efIndex].file_delete = extraFields[efIndex].file_delete
            ? extraFields[efIndex].file_delete
            : [];
        let itemsss = [];
        for (let i in extraFields) {
            if (extraFields[i].field_id == fId) {
                for (let k = 0; k < extraFields[i]["fieldValue"].length; k++) {
                    if (extraFields[i]["fieldValue"][k].constructor === String) {
                        if (items.includes(extraFields[i]["fieldValue"][k])) {
                            itemsss.push(extraFields[i]["fieldValue"][k]);
                        } else {
                            for (let j in extraFields[i].prevfieldValue) {
                                // console.log("false",extraFields[i],extraFields[i].billUrls.length,j,k);
                                if (
                                    extraFields[i]["fieldValue"][k] ==
                                    extraFields[i].prevfieldValue[j]
                                ) {
                                    extraFields[efIndex].file_delete.push(j);
                                    extraFields[efIndex].billUrls.splice(
                                        extraFields[efIndex].billUrls.indexOf(
                                            extraFields[i]["fieldValue"][k]
                                        ),
                                        1
                                    );
                                }
                            }
                        }
                    } else {
                        if (items.includes(extraFields[i]["fieldValue"][k].name)) {
                            itemsss.push(extraFields[i]["fieldValue"][k]);
                        } else {
                            extraFields[i].billUrls = extraFields[i].billUrls.splice(k, 1);
                        }
                    }
                }
            }
        }
        this._handleExtraCommon(type, fId, items, "delete", status);
        extraFields[efIndex].fieldValue = itemsss;
        ExtraFieldStores._editExtraFieldMain(type, extraFields);
    },
    _handleBACCFieldChange: function(fId, type, fieldName, event, value) {
        this._handleExtraCommon(type, fId, value, fieldName);
    },
    _handleDRFieldChange: function(fId, type, fieldName, event, value) {
        console.log("_handleDRFieldChange", fId, type, fieldName, event, value);
        this._handleExtraCommon(type, fId, value, fieldName);
    },
    _handleExtraSelectChange: function(fId, type, event, index, value) {
        // console.log("_handleExtraSelectChange",fId,value);
        // console.log('_handleExtraSelectChange',fId,type,index,value);
        if (index && index.length) {
            // console.log('value', event);
            let indexes = index.filter(function(elem, index, self) {
                return index == self.indexOf(elem);
            });

            this._handleExtraCommon(type, fId, indexes);
        } else this._handleExtraCommon(type, fId, value);
    },
    _handleFileUpload(fId, type, event, index, value) {
        let id = "myEFFile-" + fId;
        let file = document.getElementById(id).files;
        this._handleExtraCommon(type, fId, file /*document.getElementById('myEFFile').files*/);
    },
    handleDelete(id, type, i) {
        dependentEFTags[id].splice(i, 1);
        this._handleExtraDependentCommon(type, id, dependentEFTags[id]);
    },
    handleAddition(id, type, tag) {
        dependentEFTags[id] = dependentEFTags[id] || [];
        if (dependentEFTags[id].length) {
            for (let i = 0; i < dependentEFTags[id].length; i++) {
                if (
                    dependentEFTags[id][i].text &&
                    tag &&
                    dependentEFTags[id][i].text.toUpperCase() == tag.trim().toUpperCase()
                ) {
                    return false;
                }
            }
        }

        let trimTag = tag.trim();
        if (!trimTag) {
            return;
        }

        dependentEFTags[id].push({
            id: dependentEFTags[id].length + 1,
            text: trimTag
        });

        this._handleExtraDependentCommon(type, id, dependentEFTags[id]);
    },
    _setDependentList: function(key, dependent_id) {
        if (dependent_id == "extraField") {
            dependentEFTags = {};
        } else {
            delete dependentEFTags[key];
        }
    },
    _setDependentFieldValue: function(dependentType, id, type, fromPage, value) {
        let disabled = fromPage?.indexOf("show") != -1 ? true : false;
        let dep_ef = ExtraFieldStores._getextraFields("dependent") || {};

        if (
            (type == "dropdown" || type == "multi_select_dropdown") &&
            fromPage !== previousEFId &&
            fromPage !== "add"
        ) {
            dependentEFTags = dep_ef;
            previousEFId = fromPage;
        } else if (fromPage === "add" && Object.keys(dep_ef).length == 0) {
            dependentEFTags = {};
        } else {
            dependentEFTags = dep_ef;
        }
        if (type == "text") {
            return (
                <TextField
                    key={`${type}-${id}`}
                    disabled={disabled}
                    value={dep_ef[id]}
                    hintText={"Type value"}
                    onChange={this._handleDependentExtraFieldChange.bind(this, id, type)}
                    underlineStyle={{ width: "368px", border: "solid 1px #606060" }}
                    underlineFocusStyle={{ width: "368px", border: "solid 1px #237bfb" }}
                    style={{ width: "368px", fontSize: "16px", color: "#606060" }}
                />
            );
        } else if (type == "number") {
            return (
                <TextField
                    key={`${type}-${id}`}
                    disabled={disabled}
                    hintText={"Type value"}
                    value={dep_ef[id]}
                    onChange={this._handleDependentExtraFieldChange.bind(this, id, type)}
                    underlineStyle={{ width: "368px", border: "solid 1px #606060" }}
                    underlineFocusStyle={{ width: "368px", border: "solid 1px #237bfb" }}
                    style={{ width: "368px", fontSize: "16px", color: "#606060" }}
                />
            );
        } else if (type == "dropdown" || type == "multi_select_dropdown") {
            return (
                <ReactTags
                    key={`${type}-${id}`}
                    classNames={{
                        selected: "ReactTags__selected tagsClass"
                    }}
                    readOnly={disabled}
                    style={{ width: "350px" }}
                    tags={dependentEFTags[id] || []}
                    placeholder={i18n.t("placeholder.addValueForDropdown")}
                    autofocus={false}
                    handleDelete={this.handleDelete.bind(this, id, type)}
                    handleAddition={this.handleAddition.bind(this, id, type)}
                    allowDeleteFromEmptyInput={false}
                />
            );
        } else if (type == "date") {
            return (
                <DatePicker
                    key={`${type}-${id}`}
                    disabled={disabled}
                    onChange={this._handleDependentExtraFieldChange.bind(this, id, type)}
                    underlineStyle={{ width: "368px", border: "solid 1px #606060" }}
                    underlineFocusStyle={{ width: "368px", border: "solid 1px #237bfb" }}
                    style={{ width: "368px", fontSize: "16px", color: "#606060" }}
                    mode="landscape"
                    autoOk={true}
                />
            );
        }
    },
    _callAPI: function(uri, method, data, target, cType) {
        _callAPI.call(api, uri, method, data, target, cType);
    },
    _callMultipleApi: function(uri, method, data, target, cType) {
        _callMultipleApi(api, uri, method, data, target, cType);
    },

    _callApiWithoutBaseURL: function(uri, method, data, target, cType) {
        _callApiWithoutBaseURL.call(api, uri, method, data, target, cType);
    },

    _redirectToLogin: function(isSSO) {
        let mailApprovalIns = new Inmailapproval(window.location, isSSO); //calling the constructor.to initialise url obj.
        if (mailApprovalIns._getAutoDirectStatus() && !isSSO) {
            history.push(mailApprovalIns._getIntialUrl()); //landing page, in case of in mail approval,if user is unauthorised.
        } else {
            dispatcher.dispatch({
                type: "CLEAR_ALL"
            });
            history.replace("/");
        }
    },

    _redirectToDashboard: function() {
        history.replace("/dashboard");
    },

    _populateMenus(attachmentArr, from_mr_list_page) {
        let menuitemArr = [];
        if (attachmentArr && attachmentArr.length) {
            attachmentArr.forEach((el, i) => {
                menuitemArr.push(
                    <MenuItem
                        value={el}
                        key={`${i}-"attachment"`}
                        id={`${i}-"attachment"`}
                        primaryText={
                            <div style={{ display: "inline-flex" }}>
                                <div>
                                    {i + 1}.{i18n.t("tableHeader.attachment")}
                                </div>
                                <div onClick={this._multiEFFilesDownload.bind(this, el)}>
                                    <IconButton
                                        iconClassName="material-icons"
                                        iconStyle={{ cursor: "pointer", color: "#000000" }}
                                    >
                                        file_download
                                    </IconButton>
                                </div>
                                {!from_mr_list_page ? (
                                    <div
                                        onClick={this._handleShowImage.bind(this, attachmentArr, i)}
                                        style={{ marginTop: "6px" }}
                                    >
                                        <i className="material-icons" style={{ cursor: "pointer" }}>
                                            wallpaper
                                        </i>
                                    </div>
                                ) : null}
                            </div>
                        }
                    />
                );
            });
            return menuitemArr;
        }
    },

    _multiEFFilesDownload(urls) {
        let link = document.createElement("a");
        link.setAttribute("download", null);
        link.setAttribute("target", "_blank");
        link.style.display = "none";
        link.setAttribute("href", urls);
        link.click();
    },
    _handleShowImage(attachmentArr, indexImg) {
        UserInfoStore._openLightBox(attachmentArr, indexImg);
    },
    _infoButton(extra_field, from_mr_list_page) {
        let extraFieldUi = [];
        if (extra_field && Object.keys(extra_field) && Object.keys(extra_field).length) {
            //extraFieldUi.push(<br/>);
            let arr = Object.keys(extra_field).map(function(key) {
                return Object.assign(extra_field[key], { key: key });
            });
            extra_field = Common._sortDropdown(arr, "index_number", true);
            for (let key in extra_field) {
                // console.log("api ka ef", key, "ef" ,extra_field[key],"name_type", extra_field[key].name_type );

                if (extra_field[key].name_type == "file") {
                    let values = extra_field[key].field_value;
                    let val = [];
                    let attachments = [];
                    if (values) {
                        attachments = Object.keys(values).map(el => {
                            return values[el];
                        });
                    }
                    // console.log(attachments.length)
                    if (attachments.length > 0) {
                        /*val.push(<span 
							onClick={this._multiEFFilesDownload.bind(this,attachments)} 
							style={{cursor:'pointer',textDecoration:'underline'}} 
							key={`file-${values}`}>
							{`${attachments.length} attachment`}{attachments.length > 1 ? `s` : ``}
						</span>);*/
                        val.push(
                            <div style={{ display: "inline" }}>
                                <IconMenu
                                    anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
                                    key={`upload-${values}`}
                                    iconButtonElement={
                                        <div
                                            style={{
                                                cursor: "pointer",
                                                textDecoration: "underline",
                                                verticalAlign: "middle",
                                                top: 8
                                            }}
                                        >
                                            {`${attachments.length} attachment`}
                                            {attachments.length > 1 ? `s` : ``}
                                        </div>
                                    }
                                    value={`file-${values}`}
                                >
                                    {this._populateMenus(attachments, from_mr_list_page)}
                                </IconMenu>
                                {/* {showLightBoxflag ? 
				        		<GenericLightBox
				                	billUrls={billUrlsData || []}
				                	index={imgIndex}
				                	fileUploadOption={false}
				                	_closeLightbox={this._handleCloseLightBox.bind(this)}
			                	/>: ""}*/}
                            </div>
                        );
                    } else {
                        val.push(<span key="no-file">{i18n.t("err.noAttachmentsFound")}</span>);
                    }
                    extraFieldUi.push(
                        <p key={`file-${extra_field[key].field_id}`}>
                            {extra_field[key].key} : {val}
                        </p>
                    );
                } else if (extra_field[key].name_type == "multi_select_dropdown") {
                    if (extra_field[key].field_value && extra_field[key].field_value.length) {
                        extraFieldUi.push(
                            <p key={extra_field[key].field_id} style={{ wordWrap: "break-word" }}>
                                {extra_field[key].key} : {extra_field[key].field_value.join()}
                            </p>
                        );
                    }
                    /*extraFieldUi.push(
						<p key={extra_field[key].field_id}>{key} : {extra_field[key].field_value.length ? extra_field[key].field_value.join() : "No Values"}</p>
					);*/
                } else if (extra_field[key].name_type == "date_range") {
                    let date = JSON.parse(extra_field[key].field_value);
                    // console.log('from',date.from,'to',date.to);
                    if (extra_field[key].field_value.length) {
                        extraFieldUi.push(
                            <div key={extra_field[key].field_id}>
                                <p style={{ wordWrap: "break-word" }}>
                                    From {extra_field[key].key} : {date.from}
                                </p>
                                <p style={{ wordWrap: "break-word" }}>
                                    To {extra_field[key].key} : {date.to}
                                </p>
                            </div>
                        );
                    }
                } else {
                    if (extra_field[key].field_value.length) {
                        extraFieldUi.push(
                            <p key={extra_field[key].field_id}>
                                {extra_field[key].key} :{" "}
                                {extra_field[key].field_value
                                    ? extra_field[key].field_value
                                    : "No Values"}
                            </p>
                        );
                    }
                }
            }
        }
        // console.log(extraFieldUi.length);
        // if(extraFieldUi.length < 2){
        // 	extraFieldUi.push(<div key="no-ef"><br/><p>No Extra Field found !</p></div>);
        // }
        return extraFieldUi;
    },
    ifscCodeCheck: function(ifsc_code, target) {
        dispatcher.dispatch({
            type: "LOADER",
            loader: true
        });
        this._callAPI(Url.GET_IFSC, "get", { ifsc_code: ifsc_code }, (type, dt) => {
            if (type == "success") {
                let data = {}; //dt.res_data;
                data["bank_name"] = dt.res_data.bank.bank_name;
                data["branch_name"] = dt.res_data.bank.branch_name;
                target(data);
            } else {
                dispatcher.dispatch({
                    type: "NEWSNACKBAR",
                    str: this._showErrorMsg(dt.status, dt.responseJSON || ""),
                    toastType: 1
                });
                target(null);
            }
            dispatcher.dispatch({
                type: "LOADER",
                loader: false
            });
        });
    },
    parseURLParams: url => {
        const queryStart = url.indexOf("?") + 1,
            queryEnd = url.indexOf("#") + 1 || url.length + 1,
            query = url.slice(queryStart, queryEnd - 1),
            pairs = query.replace(/\+/g, " ").split("&"),
            parms = {};
            let i, n, v, nv;
      
        if (query === url || query === "") return;
      
        for (i = 0; i < pairs.length; i++) {
            nv = pairs[i].split("=", 2);
            n = decodeURIComponent(nv[0]);
            v = decodeURIComponent(nv[1]);
      
            if (!parms.hasOwnProperty(n)) parms[n] = [];
            parms[n].push(nv.length === 2 ? v : null);
        }
        return parms;
    },
    create_UUID: () => {
        let dt = new Date().getTime();
        let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            let r = (dt + Math.random()*16)%16 | 0;
            dt = Math.floor(dt/16);
            return (c === 'x' ? r :(r&0x3|0x8)).toString(16);
        });
        return "gmail-addon" + uuid;
    }
};

export default api;
